// extracted by mini-css-extract-plugin
export var MyLocation = "index-module--MyLocation--RusL9";
export var heading = "index-module--heading--Xd842";
export var icon = "index-module--icon--8x8On";
export var linkhover = "index-module--linkhover--Uo+Fz";
export var screenreader = "index-module--screenreader--LS90i";
export var title = "index-module--title--DBjXy";
export var top = "index-module--top--OtT2V";